import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container my-5">
      <>
        <h1>
          <span>Terms and Conditions of Sale</span>
        </h1>
        <p>Silverline Logistics Limited</p>
        <p>Trading as Silverline Auto</p>
        <p>Company Number: 10378532</p>
        <p>
          Registered Address: Unit 2, Pool Road Industrial Estate, Nuneaton,
          CV10 9AE
        </p>
        <p>Telephone: 07496 360002</p>
        <p>Email: inquiry@silverlineautoltd.co.uk</p>
        <p>Website: www.silverlineautoltd.co.uk</p>
        <h3 className="western">1. Introduction</h3>
        <p>
          1.1 These Terms and Conditions ("Terms") govern the sale of used motor
          vehicles by Silverline Logistics Limited, trading as Silverline Auto
          ("we," "us," or "our"), to the customer ("you" or "your").
        </p>
        <p>
          1.2 By purchasing a vehicle from us, you agree to be bound by these
          Terms.
        </p>
        <h3 className="western">2. Vehicle Description and Inspection</h3>
        <p>
          2.1 We endeavor to ensure that all vehicles are accurately described.
          However, it is your responsibility to inspect the vehicle and satisfy
          yourself as to its condition and suitability before purchase.
        </p>
        <p>
          2.2 Any statements, descriptions, or representations made by us are
          intended as a guide only and do not constitute a warranty.
        </p>
        <h3 className="western">3. Pricing and Payment</h3>
        <p>
          3.1 All prices are in Pounds Sterling and are inclusive of VAT, unless
          otherwise stated.
        </p>
        <p>
          3.2 Payment must be made in full before the vehicle is released. We
          accept payment by bank transfer, debit card, or other agreed methods.
        </p>
        <p>
          3.3 We do not accept deposits or hold vehicles for customers. Sales
          are conducted on a first-come, first-served basis.
        </p>
        <h3 className="western">4. Vehicle Reservation</h3>
        <p>
          4.1 We do not offer vehicle reservation services. Vehicles remain
          available for sale until full payment is received.
        </p>
        <h3 className="western">5. Delivery and Collection</h3>
        <p>
          5.1 Vehicles must be collected from our premises unless otherwise
          agreed in writing.
        </p>
        <p>
          5.2 If delivery is arranged, it will be at your expense and risk. We
          will not be liable for any delays or damages incurred during delivery.
        </p>
        <h3 className="western">6. Consumer Rights</h3>
        <p>
          6.1 As a consumer, you have rights under the Consumer Rights Act 2015:
        </p>
        <p>
          6.1.1 Right to Reject: If the vehicle is faulty or not as described,
          you have the right to reject it within 30 days of purchase for a full
          refund.
        </p>
        <p>
          6.1.2 Right to Repair or Replacement: If a fault is found after 30
          days but within six months, you are entitled to a repair or
          replacement. If the repair or replacement is unsuccessful, you may be
          entitled to a refund.
        </p>
        <p>
          6.1.3 Right to a Price Reduction or Final Right to Reject: If a fault
          cannot be repaired or replaced, you may request a price reduction or
          reject the vehicle for a refund, subject to a deduction for usage.
        </p>
        <p>
          6.2 These rights do not apply to faults caused by wear and tear,
          misuse, or accidents occurring after purchase.
        </p>
        <h3 className="western">7. Warranty</h3>
        <p>
          7.1 All vehicles are sold with the benefit of any remaining
          manufacturer's warranty, where applicable.
        </p>
        <p>
          7.2 We may offer additional warranties at the time of sale. These
          warranties are separate from your statutory rights and will be
          detailed in a separate agreement.
        </p>
        <p>
          7.3 Any warranty provided does not affect your legal rights under the
          Consumer Rights Act 2015.
        </p>
        <h3 className="western">8. Vehicle History and Mileage</h3>
        <p>
          8.1 We make reasonable efforts to verify the history and mileage of
          each vehicle. However, we cannot guarantee the accuracy of this
          information and accept no liability for discrepancies.
        </p>
        <h3 className="western">9. Part Exchange</h3>
        <p>
          9.1 If you offer a vehicle in part exchange, you must provide accurate
          information regarding its condition and history.
        </p>
        <p>
          9.2 We reserve the right to adjust the valuation if the part exchange
          vehicle is not as described.
        </p>
        <h3 className="western">10. Finance Agreements</h3>
        <p>
          10.1 We may introduce you to finance providers. We are not a lender
          and do not offer financial advice.
        </p>
        <p>
          10.2 Finance is subject to status and terms and conditions of the
          finance provider.
        </p>
        <p>
          10.3 We have applied for authorization from the Financial Conduct
          Authority (FCA) and are awaiting approval.
        </p>
        <h3 className="western">11. Limitation of Liability</h3>
        <p>
          11.1 Our liability for losses you suffer as a result of us breaching
          these Terms is strictly limited to the purchase price of the vehicle.
        </p>
        <p>
          11.2 We are not responsible for indirect losses, such as loss of
          income, business, or data.
        </p>
        <h3 className="western">12. Complaints</h3>
        <p>
          12.1 If you have a complaint, please contact us in writing at the
          address provided above.
        </p>
        <p>
          12.2 We will acknowledge your complaint within 5 working days and aim
          to resolve it within 14 working days.
        </p>
        <p>
          12.3 If we cannot resolve your complaint, you may refer it to The
          Motor Ombudsman or another Alternative Dispute Resolution (ADR)
          provider.
        </p>
        <h3 className="western">13. Governing Law and Jurisdiction</h3>
        <p>13.1 These Terms are governed by the laws of England and Wales.</p>
        <p>
          13.2 Any disputes arising under these Terms shall be subject to the
          exclusive jurisdiction of the courts of England and Wales.
        </p>
        <h3 className="western">14. Data Protection and GDPR</h3>
        <p>
          14.1 We are committed to protecting your personal information. Any
          data collected during the sales process will be handled in accordance
          with the UK General Data Protection Regulation (UK GDPR) and the Data
          Protection Act 2018.
        </p>
        <p>
          14.2 Your information will be used to process your purchase, and if
          necessary, shared with third-party service providers such as finance
          and warranty companies. We do not sell or share your data with third
          parties for marketing purposes without your explicit consent.
        </p>
        <p>
          14.3 You have the right to request access to, correction or deletion
          of your personal data at any time by contacting us at the details
          listed above.
        </p>
        <h3 className="western">15. MOT and Roadworthiness</h3>
        <p>
          15.1 All vehicles sold are subject to an MOT test unless stated
          otherwise. If a valid MOT is supplied, it reflects the vehicle’s
          condition at the time of testing and not necessarily at the time of
          sale.
        </p>
        <p>
          15.2 We recommend that you have the vehicle independently inspected to
          ensure roadworthiness, especially if purchasing a vehicle for
          immediate long-distance use or commercial purposes.
        </p>
        <h3 className="western">16. Vehicle Modifications</h3>
        <p>
          16.1 We do not guarantee that vehicles are free from modifications or
          alterations carried out by previous owners. It is your responsibility
          to verify the suitability of any modifications before purchase.
        </p>
        <p>
          16.2 We do not accept liability for insurance issues or mechanical
          problems arising from such modifications post-sale.
        </p>
        <h3 className="western">17. Test Drive Policy</h3>
        <p>
          17.1 Test drives may be offered at our discretion and are subject to
          the production of a valid UK driving licence and insurance
          confirmation where applicable.
        </p>
        <p>
          17.2 You will be responsible for any damage caused during a test drive
          due to reckless or negligent driving.
        </p>
        <h3 className="western">18. Misrepresentation and Fraud</h3>
        <p>
          18.1 You must provide truthful and accurate information regarding your
          identity and any part exchange vehicles.
        </p>
        <p>
          18.2 We reserve the right to cancel the transaction and take legal
          action if we suspect fraud or deliberate misrepresentation.
        </p>
        <h3 className="western">19. Force Majeure</h3>
        <p>
          19.1 We shall not be liable for any failure or delay in performance of
          our obligations under these Terms due to events beyond our reasonable
          control, including but not limited to acts of God, natural disasters,
          strikes, power failures, or internet service interruptions.
        </p>
        <h3 className="western">20. Distance and Online Sales</h3>
        <p>
          20.1 If you purchase a vehicle without visiting our premises (a
          'distance sale'), you may have the right to cancel the contract within
          14 days of delivery in accordance with the Consumer Contracts
          (Information, Cancellation and Additional Charges) Regulations 2013.
        </p>
        <p>
          20.2 If you exercise this right, you must return the vehicle in the
          same condition as received and at your own cost. A deduction may be
          made for any loss in value as a result of unnecessary handling of the
          vehicle.
        </p>
        <p>20.3 This cancellation right does not apply to in-person sales.</p>
      </>
    </div>
  );
};

export default TermsAndConditions;
